<template>
  <div class="grid-view">
    <div class="main-content" style="height: 100%">
      <div class="app-main-inner-row">
        <div class="triggers">
          <el-button v-if="showConfig" type="primary" @click="showConfigButton">
            {{ $t('CargoMsg.Cargo_Config') }}
          </el-button>
          <el-button v-if="!showConfig" type="primary" @click="addRows">
            {{ $t('common.btn.new') }}
          </el-button>
          <el-button v-if="!showConfig" type="success" size="mini" @click="saveOrderConfig">
            {{ $t('common.btn.save') }}
          </el-button>
          <el-button v-if="!showConfig" type="success" size="mini" @click="showConfigButton">
            {{ $t('common.btn.cancel') }}
          </el-button>
        </div>
      </div>
      <el-form :inline="true" label-width="80px" style="margin-top: 10px" label-position="right">
        <div class="el-form-item-wrapper">
          <el-form-item label-width="95px" :label="$t('CargoMsg.Cargo_ApplicationBranch')">
            <el-select v-model="configForm.branchId" :disabled="showConfig" filterable @change="changeOfficeHandler">
              <el-option
                v-for="office in currentOfficeList"
                :key="office.uuid"
                :value="office.officeId"
                :label="office.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :inline="false" label-width="140px" :label="$t('CargoMsg.Cargo_StartLine')">
            <el-input-number v-model="configForm.startLine" :disabled="showConfig" controls-position="right" :min="1" :max="20" />
          </el-form-item>
          <el-form-item>
            <cargo-simple-upload
              style="margin:0 5px"
              :action="URL.sys.updateOrderTemplateSample"
              :params="{branchId: configForm.branchId, lob: lob, sampleFileName: 'Import' + sampleNamePart + 'JobDataExample.xlsx'}"
              :title="$t('CargoMsg.Cargo_UploadTemplateDataSample')"
              accept=".xlsx"
              @success="refreshSample"
            />
            <a v-if="sample && sample.sampleFileName" style="display: inline-block; font-size: 100%; margin-left: 38px; color: #0d76c1" @click="downloadFile(sample.sampleFileId)">
              <i style="font-size: 18px" class="el-icon-paperclip" />
              <span style="font-size: 15px; text-decoration: underline;">{{ sample.sampleFileName + ' (' + curSampleOffice.code + $t('CargoMsg.Cargo_Sample') + ')' }}</span>
            </a>
            <i v-if="sample && sample.sampleFileName && curSampleOffice.officeId === configForm.branchId" style="font-size: 18px; margin-left: 5px; font-weight: 600; color: #7c7f80" class="el-icon-close" @click="deleteOrderTemplateSample" />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item label-width="20px" label=" ">
            <div style="display: inline-block; vertical-align: top;">
              {{ $t('CargoMsg.Cargo_TemplateTips') }}
            </div>
            <div style="display: inline-block">
              <div>
                <span style="color: #0000FF">❇{{ $t('CargoMsg.Cargo_Blue') }}</span>{{ $t('CargoMsg.Cargo_MusetSelectd') }}
              </div>
              <div style="color: #555555">
                {{ $t('CargoMsg.Cargo_Sample_Tip') }}
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="tab_style">
      <el-table
        ref="listTable"
        :data="fieldList"
        :header-cell-class-name="headerStyle"
        border
        style="width: 80%"
        max-height="550"
        highlight-current-row
        @row-click="clickRow"
      >
        <el-table-column align="center" width="70" :label="$t('CargoMsg.Cargo_SequenceNumber')">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.Cargo_ActualFieldName')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit" :style="scope.row.required === 0 ?'color: #0A0AFF': ''">
              {{ scope.row.headerField }}
            </span>
            <el-select v-if="scope.row.isEdit" v-model="scope.row.headerField" filterable :disabled="scope.row.required === 0" @change="changeHeaderField(scope.row)">
              <el-option
                v-for=" item in selectedFields"
                :key="item.headerField"
                :label="item.headerField"
                :value="item.headerField"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.Cargo_TemplateHeaderName')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.headerName }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.headerName" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.Cargo_TemplateImportValue')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">
              {{ (scope.row.importValue || scope.row.defaultValue !== '') ? scope.row.importValue : $t('CargoMsg.Cargo_TemplateDefaultValue') }}
            </span>
            <el-select v-if="scope.row.isEdit" v-model="scope.row.importValue">
              <el-option
                v-for="item in scope.row.selecteds"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.Cargo_OrderDefaultValue')">
          <template slot="header">
            <el-tooltip class="item" effect="dark" :content="$t('CargoMsg.Cargo_TemplateDefault')" placement="top-start">
              {{ $t('CargoMsg.Cargo_OrderDefaultValue') }}
              <span style="padding-left:8px;font-size: 20px">?</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.defaultValue }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.defaultValue" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.CargoFieldDescription')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.description }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.description" style="cursor:pointer" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('CargoMsg.Cargo_FieldDropdownValue')">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.options }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.options" :disabled="true" />
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" :label="$t('CargoMsg.Cargo_OrderOperation')">
          <template slot-scope="scope">
            <el-button v-if="scope.row.required === 1 && !showConfig" size="mini" icon="el-icon-delete" @click="deleteRow(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import {
  getOrderTemplateConfig,
  getOrderTemplateFields,
  saveOrderTemplateConfig
} from '@/api/sysManage/baseConfig/importOrderTemplate'
import { deleteOrderTemplateSample, getOrderTemplateSample } from '@/api/sysManage/baseConfig/importOrderTemplateSample'
import { Office } from '@/class/model/sys/Office'
import URL from '@/api/urlTranslator'
import CargoSimpleUpload from '@/components/Cargo/Common/CargoSimpleUpload'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'SeaExportTemplate',
  components: {
    CargoSimpleUpload
  },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      showConfig: true,
      isHq: false,
      fieldList: [], // 当前模板配置信息下的字段集合列
      allSelectedFields: [], // 所有的字段集合
      selectedFields: [], // 待配置的字段集合
      branchId: this.$store.getters.currentOfficeId,
      configForm: {
        name: '',
        lob: '',
        branchId: 0,
        startLine: 2,
        configContent: ''
      }, // 当前模板配置信息
      sample: {
        sampleFileName: '',
        sampleFileId: ''
      }, // 模板样例
      curSampleOffice: null,
      URL,
      storageURL: ''
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    },
    disableAdd() {
      // 若新增行未设置参数，不可以继续新增
      let isBlank = false
      this.fieldList.forEach(item => {
        if (!item.headerField) {
          isBlank = true
        }
      })
      return isBlank
    },
    sampleNamePart() {
      return this.lob === 'RB' ? 'Rail' : this.lob
    }
  },
  async created() {
    // 获取当前分公司配置信息
    await this.getAllFields()
    await this.changeOfficeHandler()
    if (this.isHq) {
      this.configForm = { ...this.configForm, branchId: 1 }
    }
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  methods: {
    // 关闭编辑功能
    closeShowConfig() {
      this.showConfig = true
    },
    // 控制是否展示配置按纽
    showConfigButton() {
      this.getAllFields()
      this.changeOfficeHandler()
      this.showConfig = !this.showConfig
      if (this.showConfig) {
        this.scrollBottom(0)
      }
    },
    // 获取所有模板字段 配置待选择字段名
    async getAllFields() {
      getOrderTemplateFields({ lob: this.lob }).then(result => {
        if (result.data !== null && result.data.length > 0) {
          const allField = []
          const selectedFields = []
          for (let i = 0; i < result.data.length; i++) {
            const { isRequired, headerField, headerName, importValue, defaultValue, importSelecteds, description, fieldOptions } = result.data[i]
            // CARGO-44099 仅在String toExoSystem = ConfigDefPsUtil.getConfigDefValue("ToExoSystem", branchId);=zy参数下调整 批量导入新增订单模板增加【可售卖产品】【全程/国内】两列必填
            const isZy = String(cache.config.get('ToExoSystem')) === 'zy'
            if (!isZy && headerField && (headerField === '可售卖产品' || headerField === '全程/国内')) {
              continue
            }
            const selects = JSON.parse(importSelecteds)
            let isExist = false
            for (let j = 0; j < this.fieldList.length; j++) {
              const field = this.fieldList[j]
              if (headerField === field.headerField) {
                isExist = true
                break
              }
            }
            // 默认置为不可编辑
            const itemFields = {
              serialNumber: this.fieldList.length + i,
              required: isRequired,
              headerField: headerField,
              headerName: headerName,
              importValue: importValue,
              defaultValue: defaultValue,
              selecteds: selects,
              description: description,
              options: fieldOptions,
              isEdit: false
            }
            if (!isExist) {
              selectedFields.push(itemFields)
            }
            allField.push(itemFields)
          }
          this.selectedFields = selectedFields
          this.allSelectedFields = allField
        }
      })
    },
    // 将当前所有行置为不可编辑 需要确认数据是否合规
    checkRowUnEdit() {
      const fieldList = []
      this.fieldList.forEach(item => {
        fieldList.push({ ...item, isEdit: false })
      })
      this.fieldList = fieldList
    },
    // 切换行中的实际业务字段名触发
    changeHeaderField(row) {
      const headerField = row.headerField
      let addRow = null
      console.log('changeHeaderField--------------', this.selectedFields)
      this.selectedFields.forEach(item => {
        if (item.headerField === headerField) {
          addRow = { ...item, isEdit: true, serialNumber: this.fieldList.length }
        }
      })
      const newList = []
      this.fieldList.forEach(item => {
        if (item.headerField !== headerField) {
          newList.push(item)
        } else {
          newList.push(addRow)
        }
      })
      this.fieldList = newList
    },
    // 切换分公司配置
    async changeOfficeHandler(event) {
      let branchId = event
      if (!event) {
        branchId = this.branchId
      }
      await getOrderTemplateConfig({ branchId: branchId, lob: this.lob }).then(result => {
        if (result.data !== null) {
          const curConfig = result.data
          this.branchId = branchId
          this.configForm = {
            branchId: branchId,
            name: curConfig.name,
            startLine: curConfig.startLine,
            lob: curConfig.lob,
            configContent: ''
          }
          if (curConfig && curConfig.configContent) {
            if (curConfig.branchId === 1 || curConfig.tenantId === 0) {
              this.isHq = true
            }
            const arrays = JSON.parse(curConfig.configContent)
            const fieldList = []
            // 取字段表中的字段取值集合作为下拉
            for (let i = 0; i < arrays.length; i++) {
              const item = arrays[i]
              let selecteds = []
              for (let j = 0; j < this.allSelectedFields.length; j++) {
                const fieldItem = this.allSelectedFields[j]
                if (fieldItem.headerField === item.headerField) {
                  selecteds = fieldItem.selecteds
                  break
                }
              }
              const value = {
                ...item,
                selecteds: selecteds,
                isEdit: false,
                serialNumber: this.getSerialNumber()
              }
              fieldList.push(value)
            }
            this.fieldList = fieldList
          }
        }
      })
      await getOrderTemplateSample({ branchId: branchId, lob: this.lob }).then(async res => {
        await this.refreshSample(res)
      })
    },
    // 选中行编辑
    clickRow(row, column, event) {
      if (this.showConfig) {
        return
      }
      // 将当前行加入到下拉字段中
      this.setSelecteFields(row)

      // 将当前行置为可编辑
      const editList = []
      this.fieldList.forEach(item => {
        let isEdit = false
        if (row.serialNumber === item.serialNumber) {
          isEdit = true
        }
        editList.push({ ...item, isEdit: isEdit })
      })
      this.fieldList = editList
    },
    // 将当前行和未选中的作为下拉字段
    setSelecteFields(row) {
      const selectedFields = []
      if (row && row.headerField) {
        selectedFields.push(row)
      }
      this.allSelectedFields.forEach(item => {
        let isExist = false
        this.fieldList.forEach(field => {
          if (field.headerField === item.headerField) {
            isExist = true
          }
        })
        if (!isExist) {
          selectedFields.push(item)
        }
      })
      this.selectedFields = selectedFields
    },
    // 新增行
    addRows() {
      // 先将所有行设置为不可编辑
      this.checkRowUnEdit()
      const fieldList = this.fieldList
      fieldList.push({
        serialNumber: this.getSerialNumber(),
        required: 1,
        headerField: '',
        headerName: '',
        importValue: '',
        defaultValue: '',
        description: '',
        // selecteds: ['模板值'],
        isEdit: true
      })
      this.fieldList = fieldList
      // 重新设置下拉选项
      this.setSelecteFields()
      this.scrollBottom(this.$refs.listTable.bodyWrapper.scrollHeight)
    },
    // 滚动到最后一行
    scrollBottom(value) {
      this.$nextTick(() => {
        this.$refs.listTable.bodyWrapper.scrollTop = value
      })
    },
    // 删除行
    deleteRow(row) {
      const fieldList = []
      this.fieldList.forEach(item => {
        if (row.headerField !== item.headerField) {
          fieldList.push(item)
        }
      })
      this.fieldList = fieldList
    },
    // 保存模板配置
    async saveOrderConfig() {
      const saveList = []
      if (this.fieldList.length === 0) {
        return
      }
      let isSave = true
      this.fieldList.forEach(item => {
        if (item.headerField) {
          if (!item.headerName) {
            isSave = false
          }
          saveList.push({
            required: item.required,
            headerField: item.headerField,
            headerName: item.headerName ? item.headerName : item.headerField,
            importValue: item.importValue,
            defaultValue: item.defaultValue,
            description: item.description,
            options: item.options
            // selecteds: item.selecteds,
            // isEdit: item.isEdit
          })
        }
      })
      if (!isSave) {
        await this.$confirm(this.$t('CargoMsg.Cargo_ContinueSave'), this.$t('CargoMsg.Cargo_Tips'), {
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {
        })
      }
      if (isSave) {
        await saveOrderTemplateConfig({ ...this.configForm, configContent: JSON.stringify(saveList) }).then(result => {
          if (result.data === 1) {
            // 刷新配置关闭编辑页
            this.showConfigButton()
            this.$message.success(this.$t('CargoMsg.Cargo_OrderTemplateSaveSuccess'))
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_OrderTemplateSaveFail'))
          }
        })
      }
    },
    // 生成随机序号
    getSerialNumber() {
      return Math.random().toString(36).substr(2)
    },
    // 标题行样式
    headerStyle() {
      return 'tableStyleClass'
    },
    // 下载文件
    downloadFile(fileId) {
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    // 上传模板数据样例成功之后执行
    async refreshSample(res) {
      if (res.data) {
        this.curSampleOffice = await Office.getOfficeById(res.data.branchId)
      } else {
        this.curSampleOffice = null
      }
      this.sample = res.data
    },
    // 删除模板数据样例
    deleteOrderTemplateSample() {
      this.$confirm(this.$t('CargoMsg.Cargo_SureDeleteTheFile'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        deleteOrderTemplateSample({ uuid: this.sample.uuid, sampleFileId: this.sample.sampleFileId }).then(res => {
          this.sample = null
          this.curSampleOffice = null
        })
      }).catch(() => false)
    }
  }
}
</script>

<style lang="scss">
.tableStyleClass {
  background: #1b5eb3 !important;
  color: white;
}

.tab_style {
  margin-top: 20px;
  margin-left: 20px;
}
</style>
